<template>
  <section id="partners" class="section" data-component="partners">
    <LazyBg :src="bgSrc" />
    <div class="container">
      <div class="section-header reveal">
        <span class="card-tag">合作伙伴</span>
        <h2 class="card-title">携手行业领先伙伴</h2>
        <p class="card-description">与全球领先的技术厂商和行业机构建立深度合作，共建算力生态</p>
      </div>
      <img
        src="../../assets/ppf.png"
        alt="合作伙伴"
        class="tech-partners-img"
        loading="lazy"
        decoding="async"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import LazyBg from '@/components/LazyBg.vue';
import bgSrc from '@/assets/home_bg3.jpg';
import '@/styles/newhome/home/partners.css';
</script>
